import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_s5pw3rw8da: FaireCollectionEntity = {
  token: "pbc_s5pw3rw8da",
  type: "collection",
  name: "Printed Baby Blankets, Hooded Towels, Bathrobes & Swaddles",
  heroImageUrl:
    "https://cdn.faire.com/fastly/2a1119e33ca13b05907179f0bb12f04ae4fe50bbe763705fc3325e8b07ba9db0.jpeg",
  itemCount: 38,
  description:
    "Lovingly crafted in India using 100% certified organic cotton grown by small-scale farmers, our products embody a commitment to ethical manufacturing, environmental sustainability, and rural empowerment. Sustainably Sourced. Ethically Made. Powered by Small Farmers.",
  brandToken: "b_7fghelgl",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-11T04:59:21.823Z",
    importedBy: "entity-db-import-collections",
  },
};
